module.exports = __webpack_public_path__ + "img/arrow-back.28438abb.svg";